import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { createDivAtom } from 'shared/atoms/factory'

import styles from './Button.module.scss'

const ButtonWrapper = createDivAtom(),
      Title = createDivAtom()

const Button = ({
  primary,
  disabled,
  title,
  onClick,
  className
}) => (
  <ButtonWrapper
    className={classNames(
      styles.button,
      primary && styles.primary,
      disabled && styles.disabled,
      className && className
    )}
    onClick={!disabled ? onClick : () => {}}
  >
    {title && (
      <Title>
        {title}
      </Title>
    )}
  </ButtonWrapper>
)

Button.propTypes = {
  primary: PropTypes.bool,
  disabled: PropTypes.bool,
  title: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string
}
Button.defaultProps = {
  primary: false
}

export default Button
